import { IDataRequest, IDataResponse, IHttpClient, STATUS_CODE } from "src/framework/providers/api";

type TipoUpload = "image" | "datasheet" | "procel" | "fabricante" | "inmetro" | "manual" | "simulacao";
export interface IUploadData {
    url: string;
    tipo: TipoUpload
}

class Componente {
    constructor(private readonly provider: IHttpClient, private readonly providerNoLoading: IHttpClient) { }

    async uploadImage({ codigoComponente, file, fileName, tipo = "image", onProgress }: { codigoComponente: string, file: File, tipo: TipoUpload, fileName?: string, onProgress: (progress: number) => void }): Promise<IUploadData | null> {
        try {

            const _fileName = fileName ? fileName : "componente-image";

            const form = new FormData();
            const name: string[] = file.name.split(".");
            const extension: string | undefined = name.pop();

            if (extension) {
                form.append(`${tipo}.${extension}`, file, file.name);
                const request: IDataRequest = {
                    url: `componentes/uploads/${codigoComponente}`,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: form,
                    onUploadProgress: (progressEvent: any) => {
                        const progress: number = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        onProgress(progress)
                    }
                };

                const response: IDataResponse = await this.providerNoLoading.post(request);

                if (response.statusCode === STATUS_CODE.OK) {
                    const idx = `${_fileName}.${extension}`;

                    return {
                        url: response.data[idx]["path"],
                        tipo: "image",
                    }
                }

                return null;
            }

            return null;
        } catch (error) {
            // TODO: Tratar error!!!
            return null;
        }
    }

    async removeUpload(codigoUpload: string): Promise<boolean> {
        try {

            return false;
        } catch (error) {
            return false;
        }
    }
}


export { Componente }